var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberlist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 21,
    viewBox: "0 0 21 21",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 5)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.5 5.5h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 9.5h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 1.5h-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1.88 3v-2.172h-.037l-.68.459v-.617l.717-.488h.717v2.818z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.89941406 5.06835938c0-.57226563.45117188-.96289063 1.109375-.96289063.65234375 0 1.04101563.35351563 1.04101563.8359375 0 .33398437-.1484375.5546875-.59765625.9609375l-.5546875.50195313v.03710937h1.18554687v.55859375h-2.14257812v-.47851562l1.0078125-.91210938c.34765625-.31835938.40625-.43945312.40625-.60546875 0-.1953125-.13671875-.35742187-.3828125-.35742187-.26171875 0-.41601563.17773437-.41601563.421875zm.71289063 4.73046874v-.484375h.36132812c.23828125 0 .39257813-.13867187.39257813-.34179687 0-.19140625-.14648438-.33203125-.38867188-.33203125-.25390625 0-.40820312.13476562-.41992187.36328125h-.65234375c.00976562-.54101563.4375-.8984375 1.10742187-.8984375.66015625 0 1.02148438.34570313 1.01953125.765625 0 .33984375-.21875.56445313-.52734375.63671875v.03710938c.40625.05664062.640625.30859374.640625.67968752 0 .5039062-.48046875.8515625-1.15820312.8515625-.66992188 0-1.125-.3613281-1.15039063-.9160157h.68359375c.00976563.2167969.18554688.3515626.45703125.3515626.26171875 0 .43945313-.1425782.43945313-.3554688 0-.22265625-.16796875-.35742188-.44335938-.35742188z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberlist);
export default __webpack_public_path__ + "static/media/numberlist.7497b08fb4569280dd15b1d290bd8371.svg";
export { ForwardRef as ReactComponent };